/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a cancellation request entry input for an order
 * @export
 * @interface CancellationRequestEntryInput
 */
export interface CancellationRequestEntryInput {
    /**
     * Order entry number of the cancelled product
     * @type {number}
     * @memberof CancellationRequestEntryInput
     */
    orderEntryNumber: number;
    /**
     * Quantity of the product which belongs to the order entry and is requested to be cancelled
     * @type {number}
     * @memberof CancellationRequestEntryInput
     */
    quantity: number;
}

/**
 * Check if a given object implements the CancellationRequestEntryInput interface.
 */
export function instanceOfCancellationRequestEntryInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "orderEntryNumber" in value;
    isInstance = isInstance && "quantity" in value;

    return isInstance;
}

export function CancellationRequestEntryInputFromJSON(json: any): CancellationRequestEntryInput {
    return CancellationRequestEntryInputFromJSONTyped(json, false);
}

export function CancellationRequestEntryInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancellationRequestEntryInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orderEntryNumber': json['orderEntryNumber'],
        'quantity': json['quantity'],
    };
}

export function CancellationRequestEntryInputToJSON(value?: CancellationRequestEntryInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'orderEntryNumber': value.orderEntryNumber,
        'quantity': value.quantity,
    };
}

